// 图片HOST路径（根据环境自动切换：dev→本地后端，prod→生产服务器）
export const IMG_PATH = process.env.BASE_API + "/img/";
// 生产环境硬编码（如需回退可取消注释下行）
// export const IMG_PATH = "https://hd.hdmicrowave.com/img/";

// 订单状态
export const ORDER_STATE = {
  NON_PAYMENT: 0,
  WAIT_HANDLE: 1,
  WAIT_SHIPMENT: 2,
  COMPLETED: 3,
  CLOSED: 4
};
// 订单状态对应文本
export const ORDER_STATE_LABEL = {
  [ORDER_STATE.NON_PAYMENT]: "待付款",
  [ORDER_STATE.WAIT_HANDLE]: "待处理",
  [ORDER_STATE.WAIT_SHIPMENT]: "待发货",
  [ORDER_STATE.COMPLETED]: "已完成",
  [ORDER_STATE.CLOSED]: "已取消"
};
// 订单状态下拉选项列表
export const ORDER_STATE_STATUS_OPTIONS = [
  // 当前创建订单后默认进入【待处理】状态，因此第一期不展示【待付款】状态
  // {
  //   value: ORDER_STATE.NON_PAYMENT,
  //   label: ORDER_STATE_LABEL[ORDER_STATE.NON_PAYMENT]
  // },
  {
    value: ORDER_STATE.WAIT_HANDLE,
    label: ORDER_STATE_LABEL[ORDER_STATE.WAIT_HANDLE]
  },
  {
    value: ORDER_STATE.WAIT_SHIPMENT,
    label: ORDER_STATE_LABEL[ORDER_STATE.WAIT_SHIPMENT]
  },
  {
    value: ORDER_STATE.COMPLETED,
    label: ORDER_STATE_LABEL[ORDER_STATE.COMPLETED]
  },
  {
    value: ORDER_STATE.CLOSED,
    label: ORDER_STATE_LABEL[ORDER_STATE.CLOSED]
  }
];
// 订单来源
export const ORDER_SOURCE_TYPE = {
  PC: 1,
  ANDROID: 2,
  iOS: 3,
  MINI_PROGRAM: 4
};
// 订单来源对应文本
export const ORDER_SOURCE_TYPE_LABEL = {
  [ORDER_SOURCE_TYPE.PC]: "PC订单",
  [ORDER_SOURCE_TYPE.ANDROID]: "Android订单",
  [ORDER_SOURCE_TYPE.iOS]: "iOS订单",
  [ORDER_SOURCE_TYPE.MINI_PROGRAM]: "小程序订单"
};
// 订单来源下拉选项列表
export const ORDER_SOURCE_TYPE_STATUS_OPTIONS = [
  {
    value: ORDER_SOURCE_TYPE.PC,
    label: ORDER_SOURCE_TYPE_LABEL[ORDER_SOURCE_TYPE.PC]
  },
  {
    value: ORDER_SOURCE_TYPE.ANDROID,
    label: ORDER_SOURCE_TYPE_LABEL[ORDER_SOURCE_TYPE.ANDROID]
  },
  {
    value: ORDER_SOURCE_TYPE.iOS,
    label: ORDER_SOURCE_TYPE_LABEL[ORDER_SOURCE_TYPE.iOS]
  },
  {
    value: ORDER_SOURCE_TYPE.MINI_PROGRAM,
    label: ORDER_SOURCE_TYPE_LABEL[ORDER_SOURCE_TYPE.MINI_PROGRAM]
  }
];


// 问题类型
export const QUESTION_TYPE = {
  BASE: 1,// 标准问题卡
  LIBRARY: 2,// 问题库
  AIQA: 3,// AI问答卡
};
// 订单来源对应文本
export const QUESTION_TYPE_LABEL = {
  [QUESTION_TYPE.BASE]: "标准问题卡",
  [QUESTION_TYPE.LIBRARY]: "问题库",
  [QUESTION_TYPE.AIQA]: "AI问答卡",
};
// 订单来源下拉选项列表
export const QUESTION_TYPE_STATUS_OPTIONS = [
  {
    value: QUESTION_TYPE.BASE,
    label: QUESTION_TYPE_LABEL[QUESTION_TYPE.BASE]
  },
  {
    value: QUESTION_TYPE.LIBRARY,
    label: QUESTION_TYPE_LABEL[QUESTION_TYPE.LIBRARY]
  },
  {
    value: QUESTION_TYPE.AIQA,
    label: QUESTION_TYPE_LABEL[QUESTION_TYPE.AIQA]
  }
];

// 资讯类型
export const NEWS_TYPE = {
  WX_PUBLISH: 1,// 微信公众号
  OTHERS: 2,// 其他
};
// 资讯类型对应文本
export const NEWS_TYPE_LABEL = {
  [NEWS_TYPE.WX_PUBLISH]: "微信公众号",
  [NEWS_TYPE.OTHERS]: "其他",
};
// 资讯类型下拉选项列表
export const NEWS_TYPE_STATUS_OPTIONS = [
  {
    value: NEWS_TYPE.WX_PUBLISH,
    label: NEWS_TYPE_LABEL[NEWS_TYPE.WX_PUBLISH]
  },
  {
    value: NEWS_TYPE.OTHERS,
    label: NEWS_TYPE_LABEL[NEWS_TYPE.OTHERS]
  }
];



// WEBPACK FOOTER //
// ./src/utils/macro.js